import { NodeIds, NodeTypeKeys } from '../../utils/NodeTypeKeys';
import { Position } from '../../types';
import { Leaf } from '../Leaf';
import { Leaf as ILeaf } from '../../types';

const dropzoneAllowedNodeTypes = [
  NodeTypeKeys.displayWebContentNodeType,
  NodeTypeKeys.sendEmailNodeType,
  NodeTypeKeys.endOfFlowNodeType,
];

export class DropzoneNode extends Leaf {
  public constructor(
    allowedNodeTypes: string[] = dropzoneAllowedNodeTypes,
    position: Position = undefined,
    next: ILeaf = undefined,
    isHidden: boolean = undefined,
  ) {
    super(NodeIds.dropzone, NodeTypeKeys.dropzoneNodeType, allowedNodeTypes, { position, isHidden, next });
  }
}
